import { graphql } from '../../graphql';

export const createInvoiceMutation = graphql(`
  mutation CreateInvoiceForPackage(
    $activationType: InvoiceCreateForPackageActivationTypeEnum!
    $name: String!
    $period: Int!
  ) {
    createInvoiceForPackage(
      input: { activationType: $activationType, name: $name, period: $period }
    ) {
      errors {
        code
        message
        path
      }
      invoice {
        id
        status
        amount
        paidServices {
          id
          activeUntil
          title
          targetType
          options {
            id
            name
            price
            priceWithDiscount(paymentMethodId: "wallet")
          }
          paymentMethods {
            id
            balance
            name
            cardToken
            iconUrl
          }
        }
      }
    }
  }
`);
